export default __webpack_public_path__ + "static/media/gel-buffer-liquid-2.2c4088ac.svg";